import { AdminClientForm } from './AdminClientForm';

export default AdminClientForm;